import orderEvent from './orderEvent';
import { socketPayloadType } from './socketPayloadType';
export default {
    [socketPayloadType.ACCEPT]: orderEvent.ACCEPTED,
    [socketPayloadType.WORKER_REQUEST]: orderEvent.WORKER_REQUEST,
    [socketPayloadType.ALLOCATED]: orderEvent.ALLOCATE,
    [socketPayloadType.ALLOCATED_CANCEL]: orderEvent.ALLOCATE_CANCEL,
    [socketPayloadType.PICKUP_FINISH]: orderEvent.PICKUP_FINISH,
    [socketPayloadType.DROP_FINISH]: orderEvent.DROP_FINISH,
    [socketPayloadType.CANCEL]: orderEvent.CANCEL,
    [socketPayloadType.PICKUP_ARRIVE]: orderEvent.UPDATE,
    [socketPayloadType.DROP_INFO]: orderEvent.UPDATE,
    [socketPayloadType.PAY_AMOUNT]: orderEvent.UPDATE,
    [socketPayloadType.CUSTOMER_PHONE]: orderEvent.UPDATE,
    [socketPayloadType.RESERVATION_TIME]: orderEvent.UPDATE,
    [socketPayloadType.PICKUP_EXPECTTIME]: orderEvent.UPDATE,
    [socketPayloadType.DELIVERY_CHARGE]: orderEvent.UPDATE,
    [socketPayloadType.PAYMENT]: orderEvent.UPDATE,
    [socketPayloadType.PAYMENT_CANCEL]: orderEvent.UPDATE,
    [socketPayloadType.PAYTYPE]: orderEvent.UPDATE,
};
